import RequestAbstract from "./RequestAbstract";

export default class MedInspection extends RequestAbstract {
    get link() {
        return this.links.medInspection;
    }

    getMedInspection(id) {
        const arr = [
            { field: "id", op: "=", value: +id },
        ];

        return this.getAllFiltered([arr]);
    }

    getForClient(clientId) {
        const arr = [
            { field: "clientId", op: "=", value: clientId },
        ];

        return this.getAllFiltered([arr], this.getSortField(["-createdTime"]));
    }
}


